import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Card } from '@/components/common/Card';
import { theme } from '@/styles/theme';

const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: ${theme.spacing.lg};
`;

const IconWrapper = styled.div`
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${theme.borderRadius.medium};
  background: ${theme.colors.primary.extraLight};
  color: ${theme.colors.primary.main};

  svg {
    width: 32px;
    height: 32px;
  }
`;

const Title = styled.h3`
  font-size: ${theme.fontSizes.xl};
  font-weight: ${theme.fontWeights.semibold};
  color: ${theme.colors.text.black};
  margin: 0;
`;

const Description = styled.p`
  font-size: ${theme.fontSizes.base};
  color: ${theme.colors.text.darkGray};
  margin: 0;
  line-height: 1.6;
`;

interface FeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

export const FeatureCard = ({ icon, title, description }: FeatureCardProps) => {
  return (
    <StyledCard
      as={motion.div}
      $hoverable
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-100px' }}
      transition={{ duration: 0.4 }}
      whileHover={{ scale: 1.02, y: -8 }}
    >
      <IconWrapper>{icon}</IconWrapper>
      <Title>{title}</Title>
      <Description>{description}</Description>
    </StyledCard>
  );
};
